<script lang="ts">
  let isMenuOpen = $state(false);
</script>

<header class="header">
  <div class="header-container">
    <div class="logo">
      <span class="logo-icon">🎰</span>
      <span class="logo-text">SpinWheel<span class="highlight">Pro</span></span>
    </div>
    
    <nav class="nav" class:open={isMenuOpen}>
      <a href="#wheel-section">Play Now</a>
      <a href="#features">Features</a>
      <a href="#how-it-works">How It Works</a>
      <a href="#faq">FAQ</a>
    </nav>
    
    <button class="menu-toggle" onclick={() => isMenuOpen = !isMenuOpen}>
      {#if isMenuOpen}✕{:else}☰{/if}
    </button>
  </div>
</header>

<style>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255,255,255,0.98);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 20px rgba(0,0,0,0.1);
    z-index: 1000;
    padding: 15px 0;
  }
  
  .header-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.8rem;
    font-weight: 800;
    color: #333;
    text-decoration: none;
  }
  
  .logo-icon {
    font-size: 2.5rem;
  }
  
  .highlight {
    background: linear-gradient(45deg, #667eea, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .nav {
    display: flex;
    gap: 30px;
  }
  
  .nav a {
    color: #333;
    text-decoration: none;
    font-weight: 600;
    font-size: 1rem;
    transition: color 0.3s ease;
    position: relative;
  }
  
  .nav a:hover {
    color: #667eea;
  }
  
  .nav a::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(45deg, #667eea, #764ba2);
    transition: width 0.3s ease;
  }
  
  .nav a:hover::after {
    width: 100%;
  }
  
  .menu-toggle {
    display: none;
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: #333;
  }
  
  @media (max-width: 768px) {
    .nav {
      position: fixed;
      top: 70px;
      left: 0;
      right: 0;
      background: white;
      flex-direction: column;
      padding: 20px;
      gap: 20px;
      box-shadow: 0 5px 20px rgba(0,0,0,0.1);
      transform: translateY(-150%);
      opacity: 0;
      transition: all 0.3s ease;
    }
    
    .nav.open {
      transform: translateY(0);
      opacity: 1;
    }
    
    .menu-toggle {
      display: block;
    }
  }
</style>
